var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-12" }, [
          _c("textarea", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.newValue,
                expression: "newValue"
              }
            ],
            staticClass: "form-control text-area",
            attrs: {
              id: _vm.controlId,
              name: _vm.controlId,
              type: "text",
              disabled: !_vm.isEnabled,
              cols: "5",
              rows: "5"
            },
            domProps: { value: _vm.newValue },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.newValue = $event.target.value
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }